import { ImageContainer, IsNewMark } from "./styles";

export default function ImageFormatter({ value, isNew }: { value?: string, isNew: boolean }) {
  const noLogoUrl = "http://lk.seafoodexporussia.com/web/upload/no-logo.png"

  return (
    <ImageContainer>
      {isNew && <IsNewMark />}
      <img src={value || noLogoUrl} alt="" width="100%" />
    </ImageContainer>
  )
}
